var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-list",
    { staticClass: "pa-0" },
    [
      _c(
        "v-subheader",
        [
          _c("v-icon", { staticClass: "mr-3" }, [_vm._v("account_circle")]),
          _vm._v(
            "\n    " +
              _vm._s(
                _vm.user
                  ? _vm.user.name
                  : _vm.generateMessage("boilerplate.unknown_user")
              ) +
              "\n  "
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("v-divider"),
      _vm._v(" "),
      _vm._l(_vm.items, function(item, index) {
        return _c(
          "v-list-item",
          {
            key: index,
            attrs: {
              ripple: "ripple",
              rel: "noopener",
              href: item.href,
              target: item.target
            },
            on: { click: item.click }
          },
          [
            item.icon
              ? _c(
                  "v-list-item-action",
                  [_c("v-icon", [_vm._v(_vm._s(item.icon))])],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "v-list-item-content",
              [
                _c("v-list-item-title", [
                  _vm._v(_vm._s(_vm.generateMessage(item.title)))
                ])
              ],
              1
            )
          ],
          1
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }